exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#circle[data-v-22322ee4]{margin:auto;height:20px;width:20px;border:3px solid rgba(0,0,0,.25);border-top:3px solid var(--chat-color-spinner);border-right:3px solid var(--chat-color-spinner);border-bottom:3px solid var(--chat-color-spinner);border-radius:50%;-webkit-animation:spin-data-v-22322ee4 1s linear infinite;animation:spin-data-v-22322ee4 1s linear infinite}@-webkit-keyframes spin-data-v-22322ee4{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}@keyframes spin-data-v-22322ee4{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);

// exports
